import { ChangeEvent } from "react";
import { clsx } from "clsx";
import { HelpBlock, FormGroup, ControlLabel } from "ui-components";

type Props = {
  help?: string;
  text: string;
  value: boolean;
  onInput: (e: ChangeEvent<HTMLInputElement>, getVState: (v: string) => void) => void;
  getVState: (v: string) => void;
  error?: string;
  req?: boolean;
  asButton?: boolean;
  className?: string;
};

const Check = ({
  text,
  error,
  req = false,
  onInput,
  getVState,
  help,
  value,
  className,
  asButton = false,
}: Props) => (
  <FormGroup className={className} validationState={req && error}>
    <ControlLabel className={clsx({ checkbox: true, "as-button": asButton })}>
      {text} {req && "*"}
      <input
        onChange={e => onInput(e, getVState)}
        type="checkbox"
        required={req}
        defaultChecked={value}
      />
      <span className="checkmark" />
    </ControlLabel>

    {req && help && <HelpBlock>{help}</HelpBlock>}
  </FormGroup>
);

export default Check;
